import BorderWrapper from "src/components/atoms/BorderWrapper";
import PortfolioContent from "src/components/atoms/PortfolioContent";

const Portfolio = () => {
  const portfolios = [
    {
      title: "Profit",
      amount: "Rp 11.500.000",
      description: "0.3% Compared to 7 days ago",
      returns: "down",
    },
    {
      title: "Sales",
      amount: "Rp 56.000.000",
      description: "0.5% compared to 7 days ago",
      returns: "up",
    },
    {
      title: "Transaction",
      amount: "1.090 transactions",
      description: "same as 7 days ago",
      returns: "same",
    },
  ];
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {portfolios.map((data, index) => (
          <div key={`${data.title}-${index}`}>
            <BorderWrapper>
              <PortfolioContent {...data} />
            </BorderWrapper>
          </div>
        ))}
      </div>
    </>
  );
};

export default Portfolio;
